var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-contrast" },
    [
      _c("route-name", { attrs: { propsRouteName: "模板起草" } }),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "content"
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 5 } }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "div",
                    { staticClass: "left-title" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "合同数据库",
                            placement: "top-start"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              class:
                                _vm.tabName === "contracts" ? "active" : "",
                              on: {
                                click: function($event) {
                                  return _vm.turnTab("contracts")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                合同数据库\n              "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "items" },
                    _vm._l(_vm.contractTypeList, function(item) {
                      return _c(
                        "div",
                        {
                          key: item._id,
                          staticClass: "left-btn",
                          style: {
                            color:
                              _vm.currtType && _vm.currtType._id === item._id
                                ? "#F1461E"
                                : ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.contractItem(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.name) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("el-col", { attrs: { span: 19 } }, [
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c("el-input", {
                          staticStyle: {
                            width: "360px",
                            "margin-bottom": "20px",
                            "margin-right": "20px"
                          },
                          attrs: { placeholder: "请输入文件名", size: "small" },
                          model: {
                            value: _vm.searchVal,
                            callback: function($$v) {
                              _vm.searchVal = $$v
                            },
                            expression: "searchVal"
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.searchData }
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "el-button",
                          { attrs: { size: "small" }, on: { click: _vm.rest } },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "doc-list" },
                      _vm._l(_vm.contractInfoList, function(item) {
                        return _c(
                          "div",
                          { key: item.id, staticClass: "doc-item" },
                          [
                            _c("div", { staticClass: "doc-item-info" }, [
                              _c("img", {
                                attrs: {
                                  src: "/images/AISmart/icon/docIcon.png",
                                  alt: ""
                                }
                              }),
                              _c("div", { staticClass: "info" }, [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "font-size": "0.87vw",
                                      "font-weight": "bolder"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#777777",
                                      "font-size": "12px"
                                    }
                                  },
                                  [_vm._v(_vm._s(item.howToUse))]
                                )
                              ])
                            ]),
                            _c("span", { staticClass: "separate" }),
                            _c("div", { staticClass: "doc-action" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.draftUseTemp(item)
                                        }
                                      }
                                    },
                                    [_vm._v("立即起草")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tabName === "AIContracts",
                                      expression: "tabName === 'AIContracts'"
                                    }
                                  ],
                                  staticStyle: { "margin-top": "20px" }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push({
                                            name: "smartContract-proposed",
                                            params: {
                                              name: item.name,
                                              tplCode: item.code
                                            }
                                          })
                                        }
                                      }
                                    },
                                    [_vm._v("协同起草")]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _c("el-row", { staticClass: "pageation" }, [
                      _c(
                        "div",
                        {
                          staticClass: "page-flex-end",
                          staticStyle: { padding: "30px 0" }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.pageModel.page,
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.pageModel.pageSize,
                              layout: "sizes, prev, pager, next, total",
                              total: _vm.pageModel.total
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange
                            }
                          }),
                          _c("el-go", {
                            attrs: {
                              "page-size": _vm.pageModel.pageSize,
                              total: _vm.pageModel.total
                            },
                            on: { "current-change": _vm.handleCurrentChange }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-065d06d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-065d06d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartDoc/docDraft/draft.vue
// module id = nCNH
// module chunks = 142